if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList);
      for (let item of MutationList) {
        if (item.target.classList.contains("select__selected-value")) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "ProductMutate",
            "ProductPriceMutate"
          );
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
}

/**
 * When BSS price rules apply, item prices are replaced with two spans:
 * <span style="text-decoration: line-through...">$3.79</span><span style="color: ...">$2.96</span>
 * Compute cart estimated savings from those DOM values and update the savings display.
 */
function parsePriceToCents(text) {
  if (!text || typeof text !== 'string') return 0;
  const normalized = text.replace(/,/g, '').replace(/[^\d.]/g, '');
  const num = parseFloat(normalized);
  return Number.isNaN(num) ? 0 : Math.round(num * 100);
}

function getQuantityForPriceElement(priceElement) {
  const row = priceElement.closest('.cart-item') || priceElement.closest('tr[role="row"]') || priceElement.closest('[data-cart-item-key]');
  if (!row) return 1;
  const input = row.querySelector('.quantity__input');
  if (!input) return 1;
  const qty = parseInt(input.value, 10);
  return Number.isNaN(qty) || qty < 1 ? 1 : qty;
}

function calcBssEstimatedSavingsCents() {
  const containers = document.querySelectorAll('[bss-b2b-item-original-price]');
  let totalCents = 0;
  containers.forEach((el) => {
    const spans = el.querySelectorAll(':scope > span');
    if (spans.length >= 2) {
      const originalCents = parsePriceToCents(spans[0].textContent);
      const saleCents = parsePriceToCents(spans[1].textContent);
      if (originalCents > saleCents) {
        const qty = getQuantityForPriceElement(el);
        totalCents += (originalCents - saleCents) * qty;
      }
    }
  });
  return totalCents;
}

/**
 * Read current cart total (Your subtotal) from the DOM.
 */
function getCartTotalCents() {
  const el = document.querySelector('[bss-b2b-cart-total-price]');
  if (!el) return 0;
  return parsePriceToCents(el.textContent);
}

/**
 * Get savings: from BSS two-span prices when present, otherwise from Liquid-rendered
 * compare_at savings (already in .totals__total-value--savings).
 */
function getSavingsCents() {
  const fromBss = calcBssEstimatedSavingsCents();
  if (fromBss > 0) return fromBss;
  const savingsEl = document.querySelector('.totals__total-value--savings');
  if (savingsEl && savingsEl.textContent) return parsePriceToCents(savingsEl.textContent);
  return 0;
}

function formatMoneyCents(cents, currency) {
  const code = (currency || 'USD').trim() || 'USD';
  return new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency',
    currency: code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100);
}

function updateBssEstimatedSavings() {
  const savingsCents = getSavingsCents();
  const subtotalCents = getCartTotalCents();
  const wouldHavePaidCents = subtotalCents + savingsCents;
  const currencyEl = document.querySelector('[data-currency]');
  const currency = currencyEl ? currencyEl.dataset.currency : 'USD';

  const wouldHavePaidEls = document.querySelectorAll('.totals__total-value--would-have-paid');
  const savingsValueEls = document.querySelectorAll('.totals__total-value--savings');
  const wouldHavePaidRows = document.querySelectorAll('.totals--would-have-paid');
  const savingsRows = document.querySelectorAll('.totals--savings');

  if (savingsCents > 0) {
    wouldHavePaidEls.forEach((el) => {
      el.textContent = formatMoneyCents(wouldHavePaidCents, currency);
    });
    savingsValueEls.forEach((el) => {
      el.textContent = formatMoneyCents(savingsCents, currency);
    });
    wouldHavePaidRows.forEach((row) => {
      row.classList.remove('hidden');
      row.hidden = false;
    });
    savingsRows.forEach((row) => {
      row.classList.remove('hidden');
      row.hidden = false;
    });
  }
}

function runBssSavingsWhenReady() {
  setTimeout(updateBssEstimatedSavings, 600);
  setTimeout(updateBssEstimatedSavings, 1500);
}

/**
 * Run savings update multiple times after cart update so we catch the new DOM
 * (e.g. first item added: drawer content is replaced asynchronously).
 */
function runSavingsAfterCartUpdate() {
  [100, 400, 800, 1200].forEach((delay) => {
    setTimeout(updateBssEstimatedSavings, delay);
  });
}

function setupCartDrawerObserver() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  drawer.addEventListener('transitionend', () => {
    if (drawer.classList.contains('active')) {
      setTimeout(updateBssEstimatedSavings, 50);
      setTimeout(updateBssEstimatedSavings, 400);
    }
  });
  const observer = new MutationObserver(() => {
    if (drawer.classList.contains('active')) {
      setTimeout(updateBssEstimatedSavings, 100);
    }
  });
  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
}

document.addEventListener("DOMContentLoaded", () => {
  runBssSavingsWhenReady();
  setupCartDrawerObserver();

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      runSavingsAfterCartUpdate();
    });
  }

  const inputSearchSelector = `input[type='text']`;
  let debounceTimer;
  document.addEventListener("input", (e) => {
    if (e.target && e.target.matches(inputSearchSelector)) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        window.dispatchEvent(new Event('scroll'));
      }, 300);
    }
  });
});

let lastUrl = location.href;

setInterval(() => {
  if (location.href !== lastUrl) {
    lastUrl = location.href;
    window.dispatchEvent(new Event('scroll'));
  }
}, 300);